export interface Config {
	discordId: string;
	twitterId: string;
}

export const config: Config = {
	discordId: '126321762483830785',
	twitterId: '3044781411'
};
